import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const SquareRootNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M3.07029 12.7652C2.81671 12.1046 3.28052 11.3846 3.95964 11.3846C4.34447 11.3846 4.692 11.6259 4.84224 11.9974L6.94633 17.2L10.8293 6.11074C11.0651 5.16205 11.8821 4.5 12.817 4.5H20.473C21.0402 4.5 21.5 4.98215 21.5 5.57692C21.5 6.17169 21.0402 6.65385 20.473 6.65385H12.8215L8.71422 18.6323C8.51378 19.4379 7.81992 20 7.02595 20C6.31386 20 5.67323 19.5463 5.40735 18.8536L3.07029 12.7652Z'
            fill='currentColor'
            fillOpacity='0.64'
        />
    </svg>
));
